<template>
	<it-link :to="href" v-if="visible" :target="tx.target" :class="clazz" :style="style" v-preview="previewKey(tx.srcType, tx.srcId, tx.srcSubType)">
		<span class="fd-text" >
			<sym-icon v-if="iconName" :name="iconName" class="fd-link"></sym-icon>
			<span>{{ textContent }}</span>
		</span>
	</it-link>
</template>

<script setup lang="ts">
import {computed, ref, watchEffect} from "vue";
import usePart, {type PartProps, partProps} from "../Part";
import type {Link} from "@t/fd/fixed/Link";
import SymIcon from "../helpers/SymIcon.vue";
import ItLink from "@/router/ItLink.vue";
import {previewKey} from "@fd/helpers/Preview";
import {injectEnv} from "../Environment";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const tx = computed<Link>(() => props.part as Link);
const { visible, valueExpression, clazz, style } = usePart(props);

const textContent = valueExpression("value", "ex");
const iconName = valueExpression("icon", "iconEx");
const hrefValue = valueExpression("href", "hrefEx");
const env = injectEnv();

const hasId = computed(() => !!tx.value.srcId);
const href = ref<string|null>(null);

watchEffect(async () => {
	if (hasId.value) {
		href.value = await env.urlTo(tx.value.srcType, tx.value.srcId, tx.value.srcSubType);
	} else {
		href.value = hrefValue.value;
	}
});

</script>
<style>
.fd-text {
	color: var(--fg);
}
.fd-text.invalid-text {
    color: var(--input-error-fg);
}
.fd-text.warn-text {
    color: var(--warn-fg);
}
.fd-text.info-text {
    color: var(--green);
}
.fd-link {
	padding-right: var(--form-v-padding);
}
</style>

